<div id="app-login" class="app-login container-fluid animated" [ngClass]="{'fadeIn': !isUserLogged }">
  <div class="row">
    <div class="phone-broker" *ngIf="phone1 && phone1.phoneNumber!=''">
      <div class="row">
        <div class="col-1 phone-icon">
          <mat-icon *ngIf="phone1 && phone1.isWhatsApp" svgIcon="phone" class="icon_coin"></mat-icon>
        </div>
        <div class="col-10">
          <div class="row">
            <div class="col-12">Atendimento</div>
            <div class="col-12">{{ phone1.phoneNumber }}</div>
          </div>
        </div>
      </div>
    </div>
    <div id="left-content" class="col-6 d-flex justify-content-center align-items-center animated"
      [ngClass]="{'slideInLeft': !isUserLogged }">
      <div class="d-flex justify-content-center flex-column max-row">
        <div class="header-message">
          <h1>Redefinir sua senha</h1>
          <h2>Quase pronto, basta digitar sua nova senha abaixo. Deve ter pelo menos 6 caracteres!</h2>
          <div id="snack-bar-msg" class="snack-bar-msg">
            <div #snackBar></div>
          </div>
        </div>
        <form name="form" (ngSubmit)="loginForm.form.valid" #loginForm="ngForm" novalidate>
          <div class="form-div">
            <mat-form-field class="userinput">
              <mat-icon matPrefix class="md-18" svgIcon="login-lock"></mat-icon>
              <input (keyup)="validatorPassword2(model.newPassword)" [type]="showpassword ? 'text' : 'password'"
                matInput placeholder="nova senha" autocomplete="new-password" name="password"
                [(ngModel)]="model.newPassword" #password="ngModel" required minlength="3" maxlength="255"
                (keypress)="validChar($event)">
              <span *ngIf="model.newPassword && model.newPassword != ''" (click)="togglePassword()"
                class="showHideSuffix" matSuffix>{{showpassword ? 'ocultar': 'mostrar'}}</span>
              <mat-hint align="end" class="mt-1">
              </mat-hint>
              <mat-error *ngIf="password.value == '' && password.touched || !validPass">Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="userinput">
              <mat-icon matPrefix class="md-18" svgIcon="login-lock"></mat-icon>
              <input (keyup)="validatorPassword($event)" [type]="showpasswordConfirm ? 'text' : 'password'" matInput
                placeholder="confirme a senha" autocomplete="new-password" name="passwordConfirm"
                [(ngModel)]="model.passwordConfirm" #passwordConfirm="ngModel" required minlength="3" maxlength="255"
                (keypress)="validChar($event)">
              <span *ngIf="model.passwordConfirm && model.passwordConfirm != ''" (click)="togglePasswordConfirm()"
                class="showHideSuffix" matSuffix>{{showpasswordConfirm ? 'ocultar': 'mostrar'}}</span>
              <mat-hint align="end" class="mt-1">
              </mat-hint>
              <mat-error *ngIf="passwordConfirm.value == '' && passwordConfirm.touched || !validPass">Campo obrigatório
              </mat-error>
            </mat-form-field>
            <div class="msg-error-one" *ngIf="passwordConfirm && password && !validPass">
              <span class="message-error">{{ errorMsg01 }}</span>
            </div>
            <div class="msg-error-two" *ngIf="!passwordConfirm && !password && !validPass">
              <span class="message-error">{{ errorMsg01 }}</span>
            </div>
            <div class="row complexy-password">
              <div class="col-12 bold">Caracteres permitidos: @$*</div>
              <div class="col-12 bold">Sugestão de senha:</div>
              <div class="col-6">
                <div>
                  <mat-icon *ngIf="passwordComplexyLength" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyLength" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyLength }">Pelo menos 8 caracteres</span>
                </div>
                <div>
                  <mat-icon *ngIf="passwordComplexyNumber" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyNumber" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyNumber }">Use números de 0-9</span>
                </div>
                <div>
                  <mat-icon *ngIf="passwordComplexySpecial" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexySpecial" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexySpecial }">Inclua um caractere especial</span>
                </div>
              </div>
              <div class="col-6">
                <div>
                  <mat-icon *ngIf="passwordComplexyLetterDown" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyLetterDown" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyLetterDown }">Use letras minúsculas (a-z)</span>
                </div>
                <div>
                  <mat-icon *ngIf="passwordComplexyLetterUp" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyLetterUp" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyLetterUp }">Use letras maiúscula (A-Z)</span>
                </div>
              </div>
            </div>
          </div>
          <div class="button-submit">
            <div class="button-progress">
              <div id="spinnerDiv" *ngIf="!isUserLogged && loading"
                [ngClass]="{ 'fadeIn': loading, 'fadeOut': !loading }" class="animated">
                <mat-spinner diameter="38" color="primary02"></mat-spinner>
              </div>
              <button
                [ngClass]="{ 'fadeIn': !loading, 'fadeOut': loading, 'error': loginForm.form.invalid && loginForm.touched && password.invalid && passwordConfirm.invalid, 'success': !loading && isUserLogged }"
                mat-raised-button color="primary01" class="animated" type="submit" (click)="send(model)"
                [disabled]="loading || loginForm.form.invalid || password.invalid || passwordConfirm.invalid || !validPass">
                DEFINIR NOVA SENHA
              </button>
            </div>
          </div>
        </form>
        <span class="new-account">Ops, lembrei a senha. <a (click)="back()">Fazer Login</a></span>
      </div>
    </div>
    <div id="carouselExampleIndicators" class="col-6 onboarding carousel slide no-padding animated"
      [ngClass]="{'slideInRight': !isUserLogged }" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
      </ol>
      <div class="carousel-inner h-100">
        <div class="carousel-item active h-100">
          <div class="d-block w-100 h-100 slide1" alt="First slide"></div>
        </div>
        <div class="carousel-item h-100">
          <div class="d-block w-100 h-100 slide2" alt="Second slide"></div>
        </div>
        <div class="carousel-item h-100">
          <div class="d-block w-100 h-100 slide3" alt="Third slide"></div>
        </div>
      </div>
    </div>
  </div>
</div>
